import { memo } from 'react';
import cn from 'bem-cn';

import { Icon, Stack } from '../../UI';

import { SlidesControlsProps } from './SlidesControls.types';
import './SlidesControls.scss';

const b = cn('slides-controls');

export const SlidesControls = memo((props: SlidesControlsProps) => {
    const { onPrev, onNext } = props;

    return (
        <Stack className={b()} direction="row">
            <Stack as="button" className={b('button')} onClick={onPrev}>
                <Icon name="chevronRight" rotate={180} />
            </Stack>
            <Stack as="button" className={b('button')} onClick={onNext}>
                <Icon name="chevronRight" />
            </Stack>
        </Stack>
    );
});

SlidesControls.displayName = 'SlidesControls';
